import { useState } from 'react';
import styled from 'styled-components';
import { addAddress } from '../../../../api/services/paymentService';
import { useSelector } from 'react-redux';
import StateOption from '../../../../components/ZipcodeOption';
import CountryOption from '../../../../components/CountryOption';

const ModalOverlay = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  max-width: 50vw;
  padding: 24px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
`;

const Input = styled.input`
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const ModalHeader = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 20px;
`;

const FormGrid = styled.div`
  display: grid;
  gap: 20px;
`;

const Row = styled.div`
  display: flex;
  gap: 20px;
`;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

const Button = styled.button`
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &.primary {
    background-color: black;
    color: white;
  }

  &.secondary {
    background-color: white;
    color: black;
    border: 1px solid black;
  }
`;

export default function AddAddressModal({ title, show, refresh, onClose }) {
  if (!show) return null;
  const userInfo = useSelector((state) => state.userInfo);

  const [addressInfo, setAddressInfo] = useState({
    idVC: userInfo.idCustomer,
    firstname: '',
    lastname: '',
    isDefault: false,
    companyNm: '',
    addr1: '',
    addr2: '',
    city: '',
    states: '',
    zipcode: '',
    country: '',
    tel: '',
  });

  const addDbAddress = async () => {
    const result = await addAddress(addressInfo);
    if (result.isAdded) {
      refresh();
      onClose();
    } else {
      alert(result.message);
    }
  };

  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalHeader>{title}</ModalHeader>
        <FormGrid>
          <Row>
            <Input
              placeholder='First Name *'
              value={addressInfo.firstname}
              onChange={(e) => {
                setAddressInfo({ ...addressInfo, firstname: e.target.value });
              }}
            />
            <Input
              placeholder='Last Name *'
              value={addressInfo.lastname}
              onChange={(e) => {
                setAddressInfo({ ...addressInfo, lastname: e.target.value });
              }}
            />
          </Row>
          <Input
            placeholder='Address *'
            value={addressInfo.addr1}
            onChange={(e) => {
              setAddressInfo({ ...addressInfo, addr1: e.target.value });
            }}
          />
          <Row>
            <CountryOption
              value={addressInfo.country}
              onChange={(e) => {
                setAddressInfo({ ...addressInfo, country: e.target.value });
              }}
            />
            <Input
              placeholder='Company *'
              value={addressInfo.companyNm}
              onChange={(e) => {
                setAddressInfo({ ...addressInfo, companyNm: e.target.value });
              }}
            />
          </Row>
          <Row>
            <Input
              placeholder='City *'
              value={addressInfo.city}
              onChange={(e) => {
                setAddressInfo({ ...addressInfo, city: e.target.value });
              }}
            />
            <StateOption
              value={addressInfo.states}
              onChange={(e) => {
                setAddressInfo({ ...addressInfo, states: e.target.value });
              }}
            />
            <Input
              placeholder='ZIP/Postal Code *'
              value={addressInfo.zipcode}
              onChange={(e) => {
                setAddressInfo({ ...addressInfo, zipcode: e.target.value });
              }}
            />
          </Row>
          <Input
            placeholder='Telephone *'
            value={addressInfo.tel}
            onChange={(e) => {
              setAddressInfo({ ...addressInfo, tel: e.target.value });
            }}
          />
          <CheckboxContainer>
            <input
              type='checkbox'
              id='defaultAddress'
              value={addressInfo.isDefault}
              onChange={(e) => {
                setAddressInfo({ ...addressInfo, isDefault: e.target.checked });
              }}
            />
            <label htmlFor='defaultAddress'>Use as my default address</label>
          </CheckboxContainer>
          <ButtonRow>
            <Button className='secondary' onClick={onClose}>
              Cancel
            </Button>
            <Button className='primary' onClick={addDbAddress}>
              Ship to this address
            </Button>
          </ButtonRow>
        </FormGrid>
      </ModalContainer>
    </ModalOverlay>
  );
}
